import * as React from 'react';
import useCopyClipboard from '../../hooks/useCopyClipboard';
import { TinyButton } from '../inputs/Button';
import Divider from '../Divider';
import styled from 'styled-components/macro';
import { GreyishBodyText } from '../Typography';

interface Props {
    header: string;
    icon: string;
    link: string;
    tooltip: string;
}
const InviteHostByLinkForm: React.FC<Props> = ({ header, icon, link, tooltip }) => {
    const [LinkCopied, setLinkCopied] = useCopyClipboard(link, { successDuration: 2000 });

    return (
        <Container>
            <Content>
                <div>
                    <TopSection>
                        <img src={icon} alt="link icon" style={{ marginRight: '15px' }} />
                        <h3>{header}</h3>
                    </TopSection>
                    <GreyishBodyText style={{ marginBottom: '30px' }}>{tooltip}</GreyishBodyText>
                </div>
                <LinkContainer>
                    <LinkText>{link}</LinkText>
                    <TinyButton onClick={setLinkCopied}>{LinkCopied ? 'Copied!' : 'copy'}</TinyButton>
                </LinkContainer>
                <Divider style={{ margin: '5px 0' }} />
            </Content>
        </Container>
    );
};


const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 106%;
    padding-left: 45px;
    padding-right: 45px;
    margin-bottom: 30px;
    background-color: #0a083f;
    border-radius: 20px;
`;
const Content = styled.div`
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
`;

const LinkContainer = styled.div`
    display: flex;
    justify-content: space-between;
    max-width: 900px;
`;

const TopSection = styled.div`
    display: flex;
    margin-bottom: 15px;
`;

const LinkText = styled.div`
    font-size: 16px;
    letter-spacing: 0.33px;
`;

export default InviteHostByLinkForm;
